export default __webpack_public_path__ + "static/PublicaSans-Regular-a938d13d97c9f003d5450a095228bf97.woff";